export default __webpack_public_path__ + "static/media/event-expo-seguridad.f89f8757.jpg";